import template from "./settings-modal.html";
import "./settings-modal.less";
import {
	TIME_DISPLAY_OPTIONS,
	EVENT_LOGOUT
} from "../../../constants";

export class Controller {
	constructor(appState, eventBus, $scope, $userProfile, uiState) {
		this.appState = appState;
		this.eventBus = eventBus;
		this.$scope = $scope;
		this.$userProfile = $userProfile;
		this.uiState = uiState;

		this.timeDisplayOptions = TIME_DISPLAY_OPTIONS;
	}

	$onInit() {
		this.userProfile = this.$userProfile.getUserProfile();

		this.timeDisplay = this.userProfile.timeDisplay;
		this.wideTableDisplay = this.userProfile.wideTableDisplay === true;

		this.eventBus.register(EVENT_LOGOUT, () => { this.handleClose(); }, this.$scope);
	}

	handleClose() {
		this.modalInstance.dismiss();
	}

	handleTimeDisplayChange() {
		this.userProfile.timeDisplay = this.timeDisplay;
		this.$userProfile.setUserProfile(this.userProfile);
	}

	handleWideTableDisplayChange() {
		this.userProfile.wideTableDisplay = this.wideTableDisplay;
		this.uiState.wideTableMode = this.wideTableDisplay;
		this.$userProfile.setUserProfile(this.userProfile);
	}
}

export default angular
	.module("vesl.components.settings-modal", [])
	.component("settingsModal", {
		controller: Controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
